<template>
	<div class="baseItemBox text-white">
		<div>
			<BlockBox title="三献服务统计" enTitle="Service Statistics" height="318">
				<template #content>
				<!-- 	<div class="tabBox">
						<div class="menuBox flex align-center justify-center">
							<div class="menuItem " :class="index==zlDataTabIndex?'checked':''"
								v-for="(item,index) in zlDataTab" :key="index" @click="zlDataTabClck(index)">
								{{ item.name }}
							</div>
						</div>
					</div> -->
					<div class="base-font-15 text-blue text-bold" style="padding:10px 10px 10px 10px;">服务次数排行榜</div>
					<div style="height:200px;padding:0 0;box-sizing: border-box">
						<dv-scroll-board :config="fwDataConfig" style="width:100%;height:210px" />
					</div>
				</template>
			</BlockBox>
		</div>
		<div class="margin-top-15">
			<BlockBox title="志愿者统计" enTitle="Volunteer Statistics" height="295">
				<template #content>
					<div style="padding:0 0;box-sizing: border-box">
						<div class="custlbBox" style="height:355px;">
							<div id="chartPeoNumQs" style="height:245px;"></div>
						</div>
					</div>
				</template>
			</BlockBox>
		</div>
		<div class="margin-top-15">
			<BlockBox title="应急救护培训视频学习统计" enTitle="Learning Statistics" height="345">
				<template #content>
					<div style="padding:0 0;box-sizing: border-box">
						<div class="custlbBox" style="height:355px;">
							<!-- <dv-scroll-board :config="mdshmxConfig" style="width:100%;height:355px" /> -->
							<div id="chartSbTjNum" style="height:285px;"></div>
						</div>
					</div>
				</template>
			</BlockBox>
		</div>


	</div>
</template>

<script>
	import echartMixins from "@/utils/resizeMixins";
	import BlockBox from '@/views/components/blockBox'
	// import notice from '@/assets/img/notice.png'
	import {

		leftData
	} from "@/api/api";
	export default {
		name: "cityGreenLand",
		components: {
			BlockBox
		},
		mixins: [echartMixins],
		data() {
			return {
				timerLeft: null,
				typeList: [],
				fwDataConfig:[],
				activityList:[],
				trainingList:[]

			}
		},

		mounted() {
			this.$nextTick(() => {
				this.getLeftData()
			})

		},
		beforeDestroy() {
			clearTimeout(this.timerLeft);
		},
		methods: {
			getLeftData() {
				let _self = this
				leftData().then(res => {
					_self.typeList = res.data.typeList
					_self.activityList=res.data.activityList
					_self.trainingList=res.data.trainingList
					let typeList=[]
					if(res.data.typeList.length>0){
						res.data.typeList.forEach((item,index)=>{
							typeList.push(['<span class="text-color-blue text-bold">TOP'+(index+1)+'</span>', item.name, item.value])
						})
					}
					_self.fwDataConfig={
						header: ['排名', '服务项目', '服务次数'],
						// indexHeader: "序号",
						data:typeList ,
						oddRowBGC: 'rgba(5,38,117,0.5)',
						evenRowBGC: 'rgba(9,79,200,0.1)',
						// index: true,
						columnWidth: [120, 200, 170]
					}
					_self.$nextTick(()=>{
						_self.drawCddjtj(_self.activityList)
						_self.drawSbtjNum(_self.trainingList)
					})
				})
			},
			

			// 人数趋势
			drawCddjtj(hstjData) {
				this.chart = this.$echarts.init(document.getElementById("chartPeoNumQs"));
				console.log(hstjData)
				let dateList = [];
				let dateValue = [];
				hstjData.forEach(obj => {
				    dateList.push(obj.name);
				    dateValue.push(obj.value);
				})
				let option = {
					grid: {
						left: '3%',
						right: '3.5%',
						bottom: '3%',
						top: 20,
						containLabel: true
					},
					tooltip: {
						trigger: 'axis'
					},
					xAxis: {
						type: 'category',

						axisTick: {
							show: false,
						},
						data: dateList,
						axisLabel: {
							textStyle: {
								color: 'rgba(255,255,255,0.7)', //更改坐标轴文字颜色
								fontSize: 10 //更改坐标轴文字大小
							}
						},
						splitLine: { //网格线
							lineStyle: {
								type: 'dotted', //设置网格线类型 dotted：虚线   solid:实线
								color: ['rgba(45,163,255,0.1)']
							},
							show: true //隐藏或显示
						},
						axisLine: {
							show: false, //隐藏或显示
							lineStyle: {
								color: '#2da3ff'
							}
						}
					},
					yAxis: {
						type: 'value',
						axisTick: {
							show: false,
						},
						axisLabel: {
							textStyle: {
								color: 'rgba(255,255,255,0.7)', //更改坐标轴文字颜色
								fontSize: 10 //更改坐标轴文字大小
							}
						},
						splitLine: { //网格线
							lineStyle: {
								type: 'dotted', //设置网格线类型 dotted：虚线   solid:实线
								color: ['rgba(45,163,255,0.1)']
							},
							show: true //隐藏或显示
						},
						axisLine: {
							show: false, //隐藏或显示
							lineStyle: {
								color: '#ffffff',
								fontSize: 10
							}
						}
					},
					series: [{
						name: '数量/人数',
						type: 'line',
						barWidth: 9,
						data: dateValue,
						itemStyle: {
							normal: {
								label: {
									show: true, //开启显示
									position: 'top', //在上方显示
									textStyle: {
										//数值样式
										color: 'white',
										fontSize: 12,
									},
								},
								color: { // 填充的颜色 // 线性渐变，前四个参数分别是 x0, y0, x2, y2, 范围从 0 - 1，相当于在图形包围盒中的百分比，如果 globalCoord 为 `true`，则该四个值是绝对的像素位置
									type: 'linear',
									x: 0,
									y: 0,
									x2: 0,
									y2: 1,
									colorStops: [{
											offset: 0,
											color: 'rgba(1, 108, 190, 1)', // 0% 处的颜色
										},
										{
											offset: 1,
											color: 'rgba(1, 38, 77, 1)' // 100% 处的颜色
										}
									],
									global: false, // 缺省为 false
								}
							}
						},

					}, ]
				};
				// echart图表自适应
				this.chart.setOption(option)
				window.addEventListener("resize", () => {
					this.chart.resize();
				});
			},
			//设备统计数据
			drawSbtjNum(hstjData) {
				this.chart = this.$echarts.init(document.getElementById("chartSbTjNum"));
				console.log(hstjData)
				let dateList = [];
				let dateValue = [];
				hstjData.forEach(obj => {
				    dateList.push(obj.name);
				    dateValue.push(obj.value);
				})
				let option = {
					grid: {
						left: '3%',
						right: '3.5%',
						bottom: '3%',
						top: 20,
						containLabel: true
					},
					tooltip: {
						trigger: 'axis'
					},
					xAxis: {
						type: 'category',

						axisTick: {
							show: false,
						},
						data: dateList,
						axisLabel: {
							textStyle: {
								color: 'rgba(255,255,255,0.7)', //更改坐标轴文字颜色
								fontSize: 10 //更改坐标轴文字大小
							}
						},
						splitLine: { //网格线
							lineStyle: {
								type: 'dotted', //设置网格线类型 dotted：虚线   solid:实线
								color: ['rgba(45,163,255,0.1)']
							},
							show: true //隐藏或显示
						},
						axisLine: {
							show: false, //隐藏或显示
							lineStyle: {
								color: '#2da3ff'
							}
						}
					},
					yAxis: {
						type: 'value',
						axisTick: {
							show: false,
						},
						axisLabel: {
							textStyle: {
								color: 'rgba(255,255,255,0.7)', //更改坐标轴文字颜色
								fontSize: 10 //更改坐标轴文字大小
							}
						},
						splitLine: { //网格线
							lineStyle: {
								type: 'dotted', //设置网格线类型 dotted：虚线   solid:实线
								color: ['rgba(45,163,255,0.1)']
							},
							show: true //隐藏或显示
						},
						axisLine: {
							show: false, //隐藏或显示
							lineStyle: {
								color: '#ffffff',
								fontSize: 10
							}
						}
					},
					series: [{
						name: '数量/个数',
						type: 'bar',
						barWidth: 9,
						data: dateValue,
						itemStyle: {
							normal: {
								label: {
									show: true, //开启显示
									position: 'top', //在上方显示
									textStyle: {
										//数值样式
										color: 'white',
										fontSize: 12,
									},
								},
								color: { // 填充的颜色 // 线性渐变，前四个参数分别是 x0, y0, x2, y2, 范围从 0 - 1，相当于在图形包围盒中的百分比，如果 globalCoord 为 `true`，则该四个值是绝对的像素位置
									type: 'linear',
									x: 0,
									y: 0,
									x2: 0,
									y2: 1,
									colorStops: [{
											offset: 0,
											color: 'rgba(1, 108, 190, 1)', // 0% 处的颜色
										},
										{
											offset: 1,
											color: 'rgba(1, 38, 77, 1)' // 100% 处的颜色
										}
									],
									global: false, // 缺省为 false
								}
							}
						},

					}, ]
				};
				// echart图表自适应
				this.chart.setOption(option)
				window.addEventListener("resize", () => {
					this.chart.resize();
				});
			},
		}
	}
</script>
<style>
	.dv-scroll-board .rows .ceil {
		padding: 0 2px !important;
	}

	.dv-scroll-board .header .header-item {
		padding: 0 2px !important;
	}
</style>

<style lang="scss">
	.baseItemBox {
		min-height: 500px;
		padding: 14px 15px 15px 15px;
		box-sizing: border-box;


		.shtjBox {
			height: 200px;

			& .swiper {
				height: 200px;
			}
		}
	}

	.custlbBox {
		::v-deep .dv-scroll-board {
			.rows {
				.ceil {
					padding: 0 5px !important;
				}
			}
		}
	}


	.hnzbLable {
		margin-top: 10px;
	}

	.hnzbLable .itemLable {
		line-height: 1;
		border: 1px solid;
		color: #2196f3;
		font-size: 12px;
		padding: 5px 7px;
		border-radius: 1px;
	}

	.hnzbLable .itemLable+.itemLable {
		margin-left: 7px;
	}

	.hnzbLable .itemLable.checked {
		background: #006AF6;
		color: #FFFFFF;
		border-color: #006AF6;
	}

	//调整
	.tabBox .menuBox {
		height: 32px;
		font-weight: normal;
		font-size: 12px;
	}

	.tabBox .menuBox .menuItem {
		padding: 0 12px;
		height: 20px;
		line-height: 20px;
		cursor: pointer;
	}

	.tabBox .menuBox .menuItem.checked {
		background: #2196f3;
	}

	.notcieIcon {
		width: 16px;
		height: 16px;
		display: inline-block;
		vertical-align: middle;
		margin-right: 5px;
	}
</style>